import BlogListing from "./BlogListing.container";

export default BlogListing;
